<pbc-filter [config]="KonstantesFilterConfig" [filter]="konstantes.filter$ | async" (filterChange)="konstantes.filter$.next($event)"></pbc-filter>
